import {remCalc} from '_themeUtils'

const navigationStylesCommons = {
    height: 'auto',
    pos: 'relative',
    left: 0,
    right: 0,
    top: 0,
    mt: 0,
    color: 'color.icon.black',
    cursor: 'pointer',
    zIndex: 0,
    _after: {
        display: 'none',
    },
}

const bannerHeader = {
    BannerHeader: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                py: {base: 'spacing.2', xl: 'spacing.3'},
                textAlign: 'center',
                borderTop: 'solid',
                borderTopWidth: remCalc(1),
            },
            navigationPrev: {
                ...navigationStylesCommons,
            },
            navigationNext: {
                ...navigationStylesCommons,
            },
            container: {
                w: {base: '95%', md: '93dvw', xl: '55dvw'},
                m: 'auto',
                px: {base: 0, md: remCalc(10), xl: 0},
                gap: {base: remCalc(2), xl: remCalc(36)},
                '.swiper-banner-header': {
                    width: '100%',
                },
                '.swiper-slide-active': {
                    transitionDelay: '1s',
                },
                '.swiper-slide': {
                    minH: {base: remCalc(21), xl: remCalc(28)},
                    alignContent: 'center',
                    alignSelf: 'center',
                    cursor: 'default',
                },
            },
        }),
        variants: {
            transparent: {
                wrapper: {
                    background: {base: 'color.background.white', xl: 'color.background.transparent'},
                    color: {base: 'color.text.black', xl: 'color.text.white'},
                    borderBottom: {base: `${remCalc(1)} solid`, xl: 'none'},
                    borderBottomColor: 'color.border.grey.300',
                    borderTopColor: {base: 'color.border.grey.300', xl: 'color.border.alpha.dark.10'},
                },
                navigationPrev: {
                    color: {base: 'color.icon.black', xl: 'color.icon.white'},
                },
                navigationNext: {
                    color: {base: 'color.icon.black', xl: 'color.icon.white'},
                },
                container: {
                    'a, button': {
                        borderColor: {base: 'color.border.black', xl: 'color.border.white'},
                        _hover: {
                            color: {base: 'color.border.black', xl: 'color.border.white'},
                        },
                    },
                    button: {
                        color: {base: 'color.text.black', xl: 'color.text.white'},
                    },
                },
            },
            solid: {
                wrapper: {
                    background: 'color.background.white',
                    color: 'color.text.black',
                    borderTopColor: 'color.border.grey.300',
                },
                container: {
                    'a, button': {
                        borderColor: 'color.border.black',
                    },
                    button: {
                        color: 'color.text.black',
                    },
                },
            },
        },
    },
}

export default bannerHeader
